import * as NameSpace from '../NameSpace'
import { ParseService } from '../../Services/parse'
import { FlexTable } from 'src/components/shared/flexTables'

const state = {
  [NameSpace.OFFER_DETAILS]: {
    data: {
      headers: [],
      aggregatedData: [],
      detailedData: [],
      functionable: null
    },
    errors: null
  },
  [NameSpace.OFFER_ITEMS]: {
    detailedData: []
  }
}

const getters = {
  [NameSpace.GET_OFFER_DETAILS_DATA]: state => {
    return state[NameSpace.OFFER_DETAILS].data
  },
  [NameSpace.GET_OFFER_DETAILS_ERRORS]: state => {
    return state[NameSpace.OFFER_DETAILS].errors
  },
  [NameSpace.GET_OFFER_ITEMS]: state => {
    return state[NameSpace.OFFER_ITEMS]
  }
}

const mutations = {
  [NameSpace.ADD_OFFER_DETAILS_DATA]: (state, payload) => {
    state[NameSpace.OFFER_DETAILS].data = payload
  },
  [NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL]: (state, payload) => {
    state[NameSpace.OFFER_DETAILS].errors = payload
  },
  [NameSpace.MUTATE_OFFER_ITEMS]: (state, payload) => {
    state[NameSpace.OFFER_ITEMS] = payload
  }
}

const actions = {
  [NameSpace.REQUEST_OFFER_DETAILS_DATA]: ({commit}, payload) => {
    let data = { offerId: payload.offerId, storeLevel: payload.storeLevel }
    if (payload.actual_calc) {
      data.actual_calc = payload.actual_calc
    }
    ParseService.getOfferDetails(data)
      .then(offerDetailsObject => {
        if (offerDetailsObject && offerDetailsObject.header && offerDetailsObject.data) {
          let tableInstance = new FlexTable(offerDetailsObject.header, offerDetailsObject.data, 1)
          let headers = tableInstance.getFixedFromSchema()
          let tableData = tableInstance.dataTableStyle('offer_select', payload.status)
          let aggregatedData = tableData.shift()
          let detailedData = tableData
          let functionable = tableData.my_offer && !tableData.lock
          if (functionable) {
            detailedData = detailedData.map(e => {
              e.selfOffer = true
              return e
            })
          }
          commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
            headers,
            aggregatedData,
            detailedData,
            functionable
          })
          commit(NameSpace.MUTATE_OFFER_ITEMS, {
            detailedData
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (typeof error === 'object') {
          if (!error.message.error.length) {
            error = 'Unknown Error!'
          }
        }
        commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, error)
        commit(NameSpace.MUTATE_OFFER_ITEMS, {
          detailedData: []
        })
      })
  },
  [NameSpace.ACTION_UPDATE_PET_DEPOT_FUNDING]: ({commit}, payload) => {
    commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, null)
    ParseService.updatePetDepotFunding({
      offerId: payload.offerId,
      storeLevel: payload.storeLevel,
      petDepotFunding: payload.petDepotFunding,
      itemId: payload.itemId
    })
      .then(offerDetailsObject => {
        if (offerDetailsObject && offerDetailsObject.header && offerDetailsObject.data) {
          let tableInstance = new FlexTable(offerDetailsObject.header, offerDetailsObject.data, 1)
          let headers = tableInstance.getFixedFromSchema()
          let tableData = tableInstance.dataTableStyle('offer_select', payload.status)
          let aggregatedData = tableData.shift()
          let detailedData = tableData
          let functionable = tableData.my_offer && !tableData.lock
          if (functionable) {
            detailedData = detailedData.map(e => {
              e.selfOffer = true
              return e
            })
          }
          commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
            headers,
            aggregatedData,
            detailedData,
            functionable
          })
          commit(NameSpace.MUTATE_OFFER_ITEMS, {
            detailedData
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (typeof error === 'object') {
          if (!error.message.error.length) {
            error = 'Unknown Error!'
          }
        }
        commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, error)
        commit(NameSpace.MUTATE_OFFER_ITEMS, {
          detailedData: []
        })
      })
  },
  [NameSpace.RESET_FUNCTIONABLE_TO_DEFAULT]: ({commit}, payload) => {
    let headers = state[NameSpace.OFFER_DETAILS].data.headers
    let aggregatedData = state[NameSpace.OFFER_DETAILS].data.aggregatedData
    let detailedData = state[NameSpace.OFFER_DETAILS].data.detailedData
    let functionable = null
    commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
      headers,
      aggregatedData,
      detailedData,
      functionable
    })
  },
  [NameSpace.RESET_OFFER_DETAILS]: ({commit}, payload) => {
    commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
      data: {
        headers: [],
        aggregatedData: [],
        detailedData: [],
        functionable: null
      },
      errors: null
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/offerDetails.js